/**
 * STT Providers Index
 *
 * Exports all STT providers and provides smart selection based on user language.
 */

export { STTProvider } from './STTProvider.js';
export { WhisperProvider } from './WhisperProvider.js';
export { MoonshineProvider } from './MoonshineProvider.js';

import { MoonshineProvider } from './MoonshineProvider.js';
import { WhisperProvider } from './WhisperProvider.js';

/**
 * Get STT provider by name
 * @param {string} providerName - 'moonshine' | 'whisper'
 * @returns {STTProvider}
 */
export function getSTTProvider(providerName) {
  switch (providerName) {
    case 'moonshine':
      return new MoonshineProvider();
    case 'whisper':
    default:
      return new WhisperProvider();
  }
}

/**
 * Smart STT provider selection based on user's preferred language
 *
 * Languages optimized for Moonshine (5x faster):
 * - English (en)
 * - Arabic (ar)
 * - Chinese (zh)
 * - Japanese (ja)
 * - Korean (ko)
 * - Ukrainian (uk)
 * - Vietnamese (vi)
 *
 * All other languages use Whisper (100+ languages supported)
 *
 * @param {string} language - User's preferred language code
 * @returns {{provider: STTProvider, providerName: string, model: string, reason: string}}
 */
export function getOptimalSTTProvider(language) {
  // TODO: Re-enable Moonshine once we verify correct model ID
  // The model 'onnx-community/moonshine-tiny-onnx' fails to load
  // Moonshine languages: ['en', 'ar', 'zh', 'ja', 'ko', 'uk', 'vi']

  // For now, use Whisper for all languages (more stable)
  return {
    provider: new WhisperProvider(),
    providerName: 'whisper',
    model: 'onnx-community/whisper-base',
    size: '~290MB',
    reason: `Whisper base for ${language} (100+ languages supported)`,
  };
}

/**
 * Check if a language is supported by local STT
 * @param {string} language - Language code
 * @returns {boolean}
 */
export function isLanguageSupported(language) {
  return MoonshineProvider.supportsLanguage(language) ||
         WhisperProvider.supportsLanguage(language);
}
